export default "__VITE_ASSET__iUfyFeNA__"